import { tierForReputation } from '../utils/reputation';

// Disc with radial halo + tier icon. Used in result screens and the
// profile hero. Prismatic tier (Mythic) uses a 5-color hard-stop
// gradient overlay.
export default function RepTrophy({ value = 0, size = 96 }) {
  const tier = tierForReputation(value);
  const color = tier.color;
  const prismatic = color.prismatic;
  const inner = size * 0.72;
  const halo = size * 1.5;

  return (
    <div style={{ position: 'relative', width: size, height: size, display: 'grid', placeItems: 'center' }}>
      <div style={{
        position: 'absolute', width: halo, height: halo, borderRadius: '50%',
        background: `radial-gradient(circle, ${color.glow}, transparent 60%)`,
        filter: 'blur(8px)', opacity: 0.85
      }} />
      <div style={{
        width: size, height: size, borderRadius: '50%',
        background: prismatic
          ? 'conic-gradient(from 30deg, #FF3E7F, #FFB347, #5BE9FF, #C09CFF, #FF3E7F)'
          : color.chip,
        boxShadow: `0 0 24px ${color.glow}`,
        display: 'grid', placeItems: 'center',
        position: 'relative'
      }}>
        <div style={{
          width: inner, height: inner, borderRadius: '50%',
          background: prismatic
            ? 'linear-gradient(160deg, #1a0a14, #08060e)'
            : color.bg,
          border: `2px solid ${color.border}`,
          display: 'grid', placeItems: 'center',
          color: color.fg,
          fontSize: size * 0.42,
          textShadow: '0 1px 0 rgba(0,0,0,.6)'
        }}>
          {tier.icon}
        </div>
        {/* Glossy shine across the upper half */}
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: '50%',
          borderRadius: `${size}px ${size}px 0 0`,
          background: 'linear-gradient(to bottom, rgba(255,255,255,0.18), transparent)',
          pointerEvents: 'none'
        }} />
      </div>
    </div>
  );
}
